import { render } from "./OrgProfileContentInfo.vue?vue&type=template&id=97a10762"
import script from "./OrgProfileContentInfo.vue?vue&type=script&lang=js"
export * from "./OrgProfileContentInfo.vue?vue&type=script&lang=js"

import "./OrgProfileContentInfo.vue?vue&type=style&index=0&id=97a10762&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__